<template>
  <!-- MOBILE -->
  <div
  v-if="$vuetify.breakpoint.xs"
  v-ripple
  :class="['c-flex-r mrow', {'selected-row': selected[item.tempID]}]">
    
    <v-icon 
    @click.stop="$emit('checkRow', item)"
    :color="selected[item.tempID] ? 'text--text' : ''"> 
      {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
    </v-icon>

    <img class="c-align-self-start" src="@/assets/img/illustrations/open.png" alt="cardboard box" width="35px">

    <div class="c-flex-c1 ml-1">
      <v-layout column>
        <div class="font-weight-medium text-sans c-flex-r1">
          <span 
          v-html="highlightedName">
          </span>
          <v-spacer></v-spacer>
          <div 
          class="c-flex-00a text--text text--darken-1 text-xs-right caption"
          xs6>
          <v-icon small color="text darken-1">mdi-clock-outline</v-icon>
            {{ supplier.lead_time }} days
          </div>
        </div>
        <div class="text--text text--darken-1 text-sans">
          <span>
            {{ supplier.email }}
          </span>
        </div>
      </v-layout>
      
    </div>

  </div>
  <!-- PC -->
  <!--
  <div
  v-else-if="false"
  v-ripple
  :class="['c-flex-r mrow', {'selected-row': selected[item.tempID]}]">

    <v-btn
    icon flat
    @click.stop="$emit('checkRow', item)">
      <v-icon> 
        {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
      </v-icon>
    </v-btn>

    <img class="c-align-self-start" src="@/assets/img/illustrations/open.png" alt="cardboard box" width="65px">

    <div class="c-flex-c1 ml-1">
      <v-layout>
        <v-flex class="c-flex-00a">
          <div :class="['font-weight-medium subheading text-sans']">
            <span 
            v-html="highlightedName"></span>
          </div>
          <div :class="['text-sans mt-1 text--text text--darken-1']">
              <span>
                {{ supplier.email }}
              </span>
            </div>
          <v-layout class="text--text text--darken-1">
            <v-icon small color="text darken-1">mdi-clock-outline</v-icon>
              Lead time: {{ supplier.lead_time }} days
          </v-layout>
        </v-flex>
      </v-layout>
      
    </div>

  </div>
  -->

  <tr v-else
  :class="{'selected': selected[item.id]}">
    <td class="sticky">
      <v-layout align-center>
        <v-btn
        icon
        @click.stop="$emit('checkRow', item)">
          <v-icon> 
            {{ selected[item.id] ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-btn>
        <v-avatar
        size="35px"
        class="mr-2">
            <img class="c-align-self-start" src="@/assets/img/illustrations/open.png" alt="cardboard box">
        </v-avatar>
        <span 
        class=""
        v-html="highlightedName">
        </span>
      </v-layout>
    </td>
    <td>
      {{ item.email }}
    </td>
    <td>
      {{ item.lead_time }} days
    </td>
  </tr>
</template>

<script>
export default {
  props: ['item', 'selected', 'searchText'],
  computed: {
    highlightedName () {
      var replacedStr = (this.searchText || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      replacedStr = this.item.name.replace(new RegExp(replacedStr, 'gi'), '<span class="font-weight-regular">$&</span>')
      return '<span class="font-weight-bold">' + replacedStr + '</span>'
    }
  }
}
</script>

<style scoped lang="scss">
.mrow {
  padding: 8px;
  cursor: pointer;
  border-bottom: thin solid rgba(0,0,0,0.15);
  position: relative;
  overflow: hidden;
  &:hover {
    background: #fafbfc;
  }
}
.selected-row {
  border-bottom: thin solid var(--v-color1-base);
  /* & ::v-deep .sticky-col {

  } */
}
.selected-row::before {
  background: var(--v-color1-base);
  height: 100%;
  width: 100%;
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  opacity: 0.1;
}
</style>

